import React from 'react';
import { Chip } from '@mui/material';

export default function PreviewChip(): JSX.Element {
  return (
    <Chip
      label="Preview"
      size="small"
      color="info"
      variant="outlined"
      sx={{ ml: 1, height: 20, fontSize: '0.65rem' }}
    />
  );
}
